import React from "react"
import {
    Box,
    Typography,
    List,
    ListItem,
    ListItemIcon,
    Divider,
} from "@mui/material"
import { Link } from "react-router-dom"
import PropTypes from "prop-types"
import theme from "../../../theme/theme"
import MenuItem from "./MenuItem"
import { TokenService } from "../../../../services/token-service"

const MenuSectionDataLake = ({
    title,
    items,
    tokenService,
    useMaxHeight = false,
}) => {
    const isAdmin = tokenService.verifyUserIsAdmin()
    const hasAccess = title.id ? tokenService.verifyPermission(title.id) : true
    const isDisabledTitleLink = !(hasAccess || isAdmin)

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "row",
                height: useMaxHeight ? "-webkit-fill-available" : "auto",
            }}
        >
            <Divider
                orientation="vertical"
                flexItem
                sx={{
                    width: 2,
                    marginRight: 2,
                    py: 3,
                    backgroundColor: theme.palette.common.white,
                    border: "none",
                    "&::before, &::after": {
                        border: "none",
                    },
                }}
            />

            <Box
                sx={{
                    flex: 1,
                    gap: 1,
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <ListItem
                    sx={{
                        display: "flex",
                        gap: 1,
                        p: 0,
                    }}
                >
                    <ListItemIcon
                        sx={{
                            minWidth: "auto",
                            p: 0,
                        }}
                    >
                        <Box
                            component={Link}
                            to={title.to}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                                textDecoration: "none",
                                cursor: isDisabledTitleLink
                                    ? "not-allowed"
                                    : "pointer",
                                color: isDisabledTitleLink
                                    ? "grey.600"
                                    : "common.white",
                                "&:hover": {
                                    color: isDisabledTitleLink
                                        ? "grey.600"
                                        : "icon.main",
                                },
                            }}
                        >
                            <Typography
                                variant="textLarge"
                                sx={{
                                    color: "inherit",
                                    textDecoration: "none",
                                }}
                            >
                                {title.name}
                            </Typography>

                            {React.cloneElement(title.icon, {
                                style: {
                                    width: 18,
                                    height: 18,
                                    paddingTop: "1px",
                                },
                            })}
                        </Box>
                    </ListItemIcon>
                </ListItem>

                <List
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        p: 0,
                        gap: 1,
                        marginTop: "auto",
                    }}
                >
                    {items.map((item, index) => {
                        const hasTokenPermission = item.id
                            ? tokenService.verifyPermission(item.id)
                            : true

                        const hasPermission = isAdmin || hasTokenPermission

                        return (
                            <MenuItem
                                key={index}
                                item={item}
                                hasPermission={hasPermission}
                            />
                        )
                    })}
                </List>
            </Box>
        </Box>
    )
}

MenuSectionDataLake.propTypes = {
    title: PropTypes.shape({
        icon: PropTypes.element.isRequired,
        name: PropTypes.string.isRequired,
        to: PropTypes.string.isRequired,
        id: PropTypes.string,
    }).isRequired,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.element.isRequired,
            name: PropTypes.string.isRequired,
            id: PropTypes.string,
        })
    ).isRequired,
    tokenService: PropTypes.instanceOf(TokenService).isRequired,
    useMaxHeight: PropTypes.bool,
}

export default MenuSectionDataLake
